export function isEditableTarget(e: KeyboardEvent): boolean {
  const target = e.target as HTMLElement | null;
  return (
    target?.tagName === "TEXTAREA" ||
    target?.tagName === "INPUT" ||
    !!target?.isContentEditable
  );
}
